import { useState } from "react";
import { ACCENTS, applyAccent, getAccent, nextAccentId } from "@/lib/accent";

export const AccentPicker = () => {
  const [current, setCurrent] = useState(getAccent());
  const cycle = () => setCurrent(applyAccent(nextAccentId(current)));
  const a = ACCENTS.find((x) => x.id === current) || ACCENTS[0];
  const next = ACCENTS.find((x) => x.id === nextAccentId(current));

  return (
    <button
      data-testid="accent-picker-btn"
      onClick={cycle}
      title={`Theme: ${a.label} — tap for ${next.label}`}
      aria-label={`Change theme, current ${a.label}`}
      className="grid h-9 w-9 place-items-center rounded-full border border-white/20 transition-transform duration-150 hover:scale-110 active:scale-90"
    >
      <span
        data-testid="accent-current-dot"
        className="h-5 w-5 rounded-full ring-1 ring-white/40"
        style={{ background: a.hex, boxShadow: `0 0 12px ${a.hex}` }}
      />
    </button>
  );
};
